export const Utility = {

};

export const SolrExhibitorTypeName = 'MkdbExhibitorIndexBundle|||Documents|||Exhibitor';
export const SolrNewsTypeName = 'MkdbExhibitorIndexBundle|||Documents|||ExhibitorNews';
export const SolrProductTypeName = 'MkdbExhibitorIndexBundle|||Documents|||ExhibitorProduct';
export const SolrBrandTypeName = 'MkdbExhibitorIndexBundle|||Documents|||Brand';
export const SolrFairTypeName = 'MkdbExhibitorIndexBundle|||Documents|||Event';
export const SolrFrameworkProgramTypeName = 'MkdbExhibitorIndexBundle|||Documents|||Contribution';
export const SolrFrameworkProgramConfigurationTypeName = 'MkdbExhibitorIndexBundle|||Documents|||Configuration';
export const SideEventsAppKey = 'sideevents';
export const SolrSpeakerTypeName = 'MkdbExhibitorIndexBundle|||Documents|||FPPerson';

export default Utility;
